"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sections = void 0;
const SectionType_1 = require("./SectionType");
/*
 * This is the list of possible WEBM file sections by their IDs.
 *
 * See:
 * - https://github.com/MediaArea/MediaInfoLib/blob/master/Source/MediaInfo/Multiple/File_Mk.cpp
 * - https://datatracker.ietf.org/doc/draft-ietf-cellar-matroska/
 */
exports.sections = {
    0xa45dfa3: { name: "EBML", type: SectionType_1.SectionType.Container },
    0x286: { name: "EBMLVersion", type: SectionType_1.SectionType.Uint },
    0x2f7: { name: "EBMLReadVersion", type: SectionType_1.SectionType.Uint },
    0x2f2: { name: "EBMLMaxIDLength", type: SectionType_1.SectionType.Uint },
    0x2f3: { name: "EBMLMaxSizeLength", type: SectionType_1.SectionType.Uint },
    0x282: { name: "DocType", type: SectionType_1.SectionType.String },
    0x287: { name: "DocTypeVersion", type: SectionType_1.SectionType.Uint },
    0x285: { name: "DocTypeReadVersion", type: SectionType_1.SectionType.Uint },
    0x6c: { name: "Void", type: SectionType_1.SectionType.Binary },
    0x3f: { name: "CRC-32", type: SectionType_1.SectionType.Binary },
    0xb538667: { name: "SignatureSlot", type: SectionType_1.SectionType.Container },
    0x3e8a: { name: "SignatureAlgo", type: SectionType_1.SectionType.Uint },
    0x3e9a: { name: "SignatureHash", type: SectionType_1.SectionType.Uint },
    0x3ea5: { name: "SignaturePublicKey", type: SectionType_1.SectionType.Binary },
    0x3eb5: { name: "Signature", type: SectionType_1.SectionType.Binary },
    0x3e5b: { name: "SignatureElements", type: SectionType_1.SectionType.Container },
    0x3e7b: { name: "SignatureElementList", type: SectionType_1.SectionType.Container },
    0x2532: { name: "SignedElement", type: SectionType_1.SectionType.Binary },
    0x8538067: { name: "Segment", type: SectionType_1.SectionType.Container },
    0x14d9b74: { name: "SeekHead", type: SectionType_1.SectionType.Container },
    0xdbb: { name: "Seek", type: SectionType_1.SectionType.Container },
    0x13ab: { name: "SeekID", type: SectionType_1.SectionType.Binary },
    0x13ac: { name: "SeekPosition", type: SectionType_1.SectionType.Uint },
    0x549a966: { name: "Info", type: SectionType_1.SectionType.Container },
    0x33a4: { name: "SegmentUID", type: SectionType_1.SectionType.Binary },
    0x3384: { name: "SegmentFilename", type: SectionType_1.SectionType.String },
    0x1cb923: { name: "PrevUID", type: SectionType_1.SectionType.Binary },
    0x1c83ab: { name: "PrevFilename", type: SectionType_1.SectionType.String },
    0x1eb923: { name: "NextUID", type: SectionType_1.SectionType.Binary },
    0x1e83bb: { name: "NextFilename", type: SectionType_1.SectionType.String },
    0x444: { name: "SegmentFamily", type: SectionType_1.SectionType.Binary },
    0x2924: { name: "ChapterTranslate", type: SectionType_1.SectionType.Container },
    0x29fc: { name: "ChapterTranslateEditionUID", type: SectionType_1.SectionType.Uint },
    0x29bf: { name: "ChapterTranslateCodec", type: SectionType_1.SectionType.Uint },
    0x29a5: { name: "ChapterTranslateID", type: SectionType_1.SectionType.Binary },
    0xad7b1: { name: "TimecodeScale", type: SectionType_1.SectionType.Uint },
    0x489: { name: "Duration", type: SectionType_1.SectionType.Float },
    0x461: { name: "DateUTC", type: SectionType_1.SectionType.Date },
    0x3ba9: { name: "Title", type: SectionType_1.SectionType.String },
    0xd80: { name: "MuxingApp", type: SectionType_1.SectionType.String },
    0x1741: { name: "WritingApp", type: SectionType_1.SectionType.String },
    // Intentionally don't recognize the Cluster section because it's large
    // 0xf43b675: { name: "Cluster", type: SectionType.Container },
    0x67: { name: "Timecode", type: SectionType_1.SectionType.Uint },
    0x1854: { name: "SilentTracks", type: SectionType_1.SectionType.Container },
    0x18d7: { name: "SilentTrackNumber", type: SectionType_1.SectionType.Uint },
    0x27: { name: "Position", type: SectionType_1.SectionType.Uint },
    0x2b: { name: "PrevSize", type: SectionType_1.SectionType.Uint },
    0x23: { name: "SimpleBlock", type: SectionType_1.SectionType.Binary },
    0x20: { name: "BlockGroup", type: SectionType_1.SectionType.Container },
    0x21: { name: "Block", type: SectionType_1.SectionType.Binary },
    0x22: { name: "BlockVirtual", type: SectionType_1.SectionType.Binary },
    0x35a1: { name: "BlockAdditions", type: SectionType_1.SectionType.Container },
    0x26: { name: "BlockMore", type: SectionType_1.SectionType.Container },
    0x6e: { name: "BlockAddID", type: SectionType_1.SectionType.Uint },
    0x25: { name: "BlockAdditional", type: SectionType_1.SectionType.Binary },
    0x1b: { name: "BlockDuration", type: SectionType_1.SectionType.Uint },
    0x7a: { name: "ReferencePriority", type: SectionType_1.SectionType.Uint },
    0x7b: { name: "ReferenceBlock", type: SectionType_1.SectionType.Int },
    0x7d: { name: "ReferenceVirtual", type: SectionType_1.SectionType.Int },
    0x24: { name: "CodecState", type: SectionType_1.SectionType.Binary },
    0x35a2: { name: "DiscardPadding", type: SectionType_1.SectionType.Int },
    0xe: { name: "Slices", type: SectionType_1.SectionType.Container },
    0x68: { name: "TimeSlice", type: SectionType_1.SectionType.Container },
    0x4c: { name: "LaceNumber", type: SectionType_1.SectionType.Uint },
    0x4d: { name: "FrameNumber", type: SectionType_1.SectionType.Uint },
    0x4b: { name: "BlockAdditionID", type: SectionType_1.SectionType.Uint },
    0x4e: { name: "Delay", type: SectionType_1.SectionType.Uint },
    0x4f: { name: "SliceDuration", type: SectionType_1.SectionType.Uint },
    0x48: { name: "ReferenceFrame", type: SectionType_1.SectionType.Container },
    0x49: { name: "ReferenceOffset", type: SectionType_1.SectionType.Uint },
    0x4a: { name: "ReferenceTimeCode", type: SectionType_1.SectionType.Uint },
    0x2f: { name: "EncryptedBlock", type: SectionType_1.SectionType.Binary },
    0x654ae6b: { name: "Tracks", type: SectionType_1.SectionType.Container },
    0x2e: { name: "TrackEntry", type: SectionType_1.SectionType.Container },
    0x57: { name: "TrackNumber", type: SectionType_1.SectionType.Uint },
    0x33c5: { name: "TrackUID", type: SectionType_1.SectionType.Uint },
    0x3: { name: "TrackType", type: SectionType_1.SectionType.Uint },
    0x39: { name: "FlagEnabled", type: SectionType_1.SectionType.Uint },
    0x8: { name: "FlagDefault", type: SectionType_1.SectionType.Uint },
    0x15aa: { name: "FlagForced", type: SectionType_1.SectionType.Uint },
    0x1c: { name: "FlagLacing", type: SectionType_1.SectionType.Uint },
    0x2de7: { name: "MinCache", type: SectionType_1.SectionType.Uint },
    0x2df8: { name: "MaxCache", type: SectionType_1.SectionType.Uint },
    0x3e383: { name: "DefaultDuration", type: SectionType_1.SectionType.Uint },
    0x34e7a: { name: "DefaultDecodedFieldDuration", type: SectionType_1.SectionType.Uint },
    0x3314f: { name: "TrackTimecodeScale", type: SectionType_1.SectionType.Float },
    0x137f: { name: "TrackOffset", type: SectionType_1.SectionType.Int },
    0x15ee: { name: "MaxBlockAdditionID", type: SectionType_1.SectionType.Uint },
    0x136e: { name: "Name", type: SectionType_1.SectionType.String },
    0x2b59c: { name: "Language", type: SectionType_1.SectionType.String },
    0x6: { name: "CodecID", type: SectionType_1.SectionType.String },
    0x23a2: { name: "CodecPrivate", type: SectionType_1.SectionType.Binary },
    0x58688: { name: "CodecName", type: SectionType_1.SectionType.String },
    0x3446: { name: "AttachmentLink", type: SectionType_1.SectionType.Uint },
    0x1a9697: { name: "CodecSettings", type: SectionType_1.SectionType.String },
    0x1b4040: { name: "CodecInfoURL", type: SectionType_1.SectionType.String },
    0x6b240: { name: "CodecDownloadURL", type: SectionType_1.SectionType.String },
    0x2a: { name: "CodecDecodeAll", type: SectionType_1.SectionType.Uint },
    0x2fab: { name: "TrackOverlay", type: SectionType_1.SectionType.Uint },
    0x16aa: { name: "CodecDelay", type: SectionType_1.SectionType.Uint },
    0x16bb: { name: "SeekPreRoll", type: SectionType_1.SectionType.Uint },
    0x2624: { name: "TrackTranslate", type: SectionType_1.SectionType.Container },
    0x26fc: { name: "TrackTranslateEditionUID", type: SectionType_1.SectionType.Uint },
    0x26bf: { name: "TrackTranslateCodec", type: SectionType_1.SectionType.Uint },
    0x26a5: { name: "TrackTranslateTrackID", type: SectionType_1.SectionType.Binary },
    0x60: { name: "Video", type: SectionType_1.SectionType.Container },
    0x1a: { name: "FlagInterlaced", type: SectionType_1.SectionType.Uint },
    0x13b8: { name: "StereoMode", type: SectionType_1.SectionType.Uint },
    0x13c0: { name: "AlphaMode", type: SectionType_1.SectionType.Uint },
    0x13b9: { name: "OldStereoMode", type: SectionType_1.SectionType.Uint },
    0x30: { name: "PixelWidth", type: SectionType_1.SectionType.Uint },
    0x3a: { name: "PixelHeight", type: SectionType_1.SectionType.Uint },
    0x14aa: { name: "PixelCropBottom", type: SectionType_1.SectionType.Uint },
    0x14bb: { name: "PixelCropTop", type: SectionType_1.SectionType.Uint },
    0x14cc: { name: "PixelCropLeft", type: SectionType_1.SectionType.Uint },
    0x14dd: { name: "PixelCropRight", type: SectionType_1.SectionType.Uint },
    0x14b0: { name: "DisplayWidth", type: SectionType_1.SectionType.Uint },
    0x14ba: { name: "DisplayHeight", type: SectionType_1.SectionType.Uint },
    0x14b2: { name: "DisplayUnit", type: SectionType_1.SectionType.Uint },
    0x14b3: { name: "AspectRatioType", type: SectionType_1.SectionType.Uint },
    0xeb524: { name: "ColourSpace", type: SectionType_1.SectionType.Binary },
    0xfb523: { name: "GammaValue", type: SectionType_1.SectionType.Float },
    0x383e3: { name: "FrameRate", type: SectionType_1.SectionType.Float },
    0x61: { name: "Audio", type: SectionType_1.SectionType.Container },
    0x35: { name: "SamplingFrequency", type: SectionType_1.SectionType.Float },
    0x38b5: { name: "OutputSamplingFrequency", type: SectionType_1.SectionType.Float },
    0x1f: { name: "Channels", type: SectionType_1.SectionType.Uint },
    0x3d7b: { name: "ChannelPositions", type: SectionType_1.SectionType.Binary },
    0x2264: { name: "BitDepth", type: SectionType_1.SectionType.Uint },
    0x62: { name: "TrackOperation", type: SectionType_1.SectionType.Container },
    0x63: { name: "TrackCombinePlanes", type: SectionType_1.SectionType.Container },
    0x64: { name: "TrackPlane", type: SectionType_1.SectionType.Container },
    0x65: { name: "TrackPlaneUID", type: SectionType_1.SectionType.Uint },
    0x66: { name: "TrackPlaneType", type: SectionType_1.SectionType.Uint },
    0x69: { name: "TrackJoinBlocks", type: SectionType_1.SectionType.Container },
    0x6d: { name: "TrackJoinUID", type: SectionType_1.SectionType.Uint },
    0x40: { name: "TrickTrackUID", type: SectionType_1.SectionType.Uint },
    0x41: { name: "TrickTrackSegmentUID", type: SectionType_1.SectionType.Binary },
    0x46: { name: "TrickTrackFlag", type: SectionType_1.SectionType.Uint },
    0x47: { name: "TrickMasterTrackUID", type: SectionType_1.SectionType.Uint },
    0x44: { name: "TrickMasterTrackSegmentUID", type: SectionType_1.SectionType.Binary },
    0x2d80: { name: "ContentEncodings", type: SectionType_1.SectionType.Container },
    0x2240: { name: "ContentEncoding", type: SectionType_1.SectionType.Container },
    0x1031: { name: "ContentEncodingOrder", type: SectionType_1.SectionType.Uint },
    0x1032: { name: "ContentEncodingScope", type: SectionType_1.SectionType.Uint },
    0x1033: { name: "ContentEncodingType", type: SectionType_1.SectionType.Uint },
    0x1034: { name: "ContentCompression", type: SectionType_1.SectionType.Container },
    0x254: { name: "ContentCompAlgo", type: SectionType_1.SectionType.Uint },
    0x255: { name: "ContentCompSettings", type: SectionType_1.SectionType.Binary },
    0x1035: { name: "ContentEncryption", type: SectionType_1.SectionType.Container },
    0x7e1: { name: "ContentEncAlgo", type: SectionType_1.SectionType.Uint },
    0x7e2: { name: "ContentEncKeyID", type: SectionType_1.SectionType.Binary },
    0x7e3: { name: "ContentSignature", type: SectionType_1.SectionType.Binary },
    0x7e4: { name: "ContentSigKeyID", type: SectionType_1.SectionType.Binary },
    0x7e5: { name: "ContentSigAlgo", type: SectionType_1.SectionType.Uint },
    0x7e6: { name: "ContentSigHashAlgo", type: SectionType_1.SectionType.Uint },
    0xc53bb6b: { name: "Cues", type: SectionType_1.SectionType.Container },
    0x3b: { name: "CuePoint", type: SectionType_1.SectionType.Container },
    0x33: { name: "CueTime", type: SectionType_1.SectionType.Uint },
    0x37: { name: "CueTrackPositions", type: SectionType_1.SectionType.Container },
    0x77: { name: "CueTrack", type: SectionType_1.SectionType.Uint },
    0x71: { name: "CueClusterPosition", type: SectionType_1.SectionType.Uint },
    0x70: { name: "CueRelativePosition", type: SectionType_1.SectionType.Uint },
    0x32: { name: "CueDuration", type: SectionType_1.SectionType.Uint },
    0x1378: { name: "CueBlockNumber", type: SectionType_1.SectionType.Uint },
    0x6a: { name: "CueCodecState", type: SectionType_1.SectionType.Uint },
    0x5b: { name: "CueReference", type: SectionType_1.SectionType.Container },
    0x16: { name: "CueRefTime", type: SectionType_1.SectionType.Uint },
    0x17: { name: "CueRefCluster", type: SectionType_1.SectionType.Uint },
    0x135f: { name: "CueRefNumber", type: SectionType_1.SectionType.Uint },
    0x6b: { name: "CueRefCodecState", type: SectionType_1.SectionType.Uint },
    0x941a469: { name: "Attachments", type: SectionType_1.SectionType.Container },
    0x21a7: { name: "AttachedFile", type: SectionType_1.SectionType.Container },
    0x67e: { name: "FileDescription", type: SectionType_1.SectionType.String },
    0x66e: { name: "FileName", type: SectionType_1.SectionType.String },
    0x660: { name: "FileMimeType", type: SectionType_1.SectionType.String },
    0x65c: { name: "FileData", type: SectionType_1.SectionType.Binary },
    0x6ae: { name: "FileUID", type: SectionType_1.SectionType.Uint },
    0x675: { name: "FileReferral", type: SectionType_1.SectionType.Binary },
    0x661: { name: "FileUsedStartTime", type: SectionType_1.SectionType.Uint },
    0x662: { name: "FileUsedEndTime", type: SectionType_1.SectionType.Uint },
    0x43a770: { name: "Chapters", type: SectionType_1.SectionType.Container },
    0x5b9: { name: "EditionEntry", type: SectionType_1.SectionType.Container },
    0x5bc: { name: "EditionUID", type: SectionType_1.SectionType.Uint },
    0x5bd: { name: "EditionFlagHidden", type: SectionType_1.SectionType.Uint },
    0x5db: { name: "EditionFlagDefault", type: SectionType_1.SectionType.Uint },
    0x5dd: { name: "EditionFlagOrdered", type: SectionType_1.SectionType.Uint },
    0x36: { name: "ChapterAtom", type: SectionType_1.SectionType.Container },
    0x33c4: { name: "ChapterUID", type: SectionType_1.SectionType.Uint },
    0x1654: { name: "ChapterStringUID", type: SectionType_1.SectionType.String },
    0x11: { name: "ChapterTimeStart", type: SectionType_1.SectionType.Uint },
    0x12: { name: "ChapterTimeEnd", type: SectionType_1.SectionType.Uint },
    0x18: { name: "ChapterFlagHidden", type: SectionType_1.SectionType.Uint },
    0x598: { name: "ChapterFlagEnabled", type: SectionType_1.SectionType.Uint },
    0x2e67: { name: "ChapterSegmentUID", type: SectionType_1.SectionType.Binary },
    0x2ebc: { name: "ChapterSegmentEditionUID", type: SectionType_1.SectionType.Uint },
    0x23c3: { name: "ChapterPhysicalEquiv", type: SectionType_1.SectionType.Uint },
    0xf: { name: "ChapterTrack", type: SectionType_1.SectionType.Container },
    0x9: { name: "ChapterTrackNumber", type: SectionType_1.SectionType.Uint },
    0x0: { name: "ChapterDisplay", type: SectionType_1.SectionType.Container },
    0x5: { name: "ChapString", type: SectionType_1.SectionType.String },
    0x37c: { name: "ChapLanguage", type: SectionType_1.SectionType.String },
    0x37e: { name: "ChapCountry", type: SectionType_1.SectionType.String },
    0x2944: { name: "ChapProcess", type: SectionType_1.SectionType.Container },
    0x2955: { name: "ChapProcessCodecID", type: SectionType_1.SectionType.Uint },
    0x50d: { name: "ChapProcessPrivate", type: SectionType_1.SectionType.Binary },
    0x2911: { name: "ChapProcessCommand", type: SectionType_1.SectionType.Container },
    0x2922: { name: "ChapProcessTime", type: SectionType_1.SectionType.Uint },
    0x2933: { name: "ChapProcessData", type: SectionType_1.SectionType.Binary },
    0x254c367: { name: "Tags", type: SectionType_1.SectionType.Container },
    0x3373: { name: "Tag", type: SectionType_1.SectionType.Container },
    0x23c0: { name: "Targets", type: SectionType_1.SectionType.Container },
    0x28ca: { name: "TargetTypeValue", type: SectionType_1.SectionType.Uint },
    0x23ca: { name: "TargetType", type: SectionType_1.SectionType.String },
    0x23c5: { name: "TagTrackUID", type: SectionType_1.SectionType.Uint },
    0x23c9: { name: "TagEditionUID", type: SectionType_1.SectionType.Uint },
    0x23c4: { name: "TagChapterUID", type: SectionType_1.SectionType.Uint },
    0x23c6: { name: "TagAttachmentUID", type: SectionType_1.SectionType.Uint },
    0x27c8: { name: "SimpleTag", type: SectionType_1.SectionType.Container },
    0x5a3: { name: "TagName", type: SectionType_1.SectionType.String },
    0x47a: { name: "TagLanguage", type: SectionType_1.SectionType.String },
    0x484: { name: "TagDefault", type: SectionType_1.SectionType.Uint },
    0x487: { name: "TagString", type: SectionType_1.SectionType.String },
    0x485: { name: "TagBinary", type: SectionType_1.SectionType.Binary },
    0x15b0: { name: "Colour", type: SectionType_1.SectionType.Container },
    0x15b1: { name: "MatrixCoefficients", type: SectionType_1.SectionType.Uint },
    0x15b2: { name: "BitsPerChannel", type: SectionType_1.SectionType.Uint },
    0x15b3: { name: "ChromaSubsamplingHorz", type: SectionType_1.SectionType.Uint },
    0x15b4: { name: "ChromaSubsamplingVert", type: SectionType_1.SectionType.Uint },
    0x15b5: { name: "CbSubsamplingHorz", type: SectionType_1.SectionType.Uint },
    0x15b6: { name: "CbSubsamplingVert", type: SectionType_1.SectionType.Uint },
    0x15b7: { name: "ChromaSitingHorz", type: SectionType_1.SectionType.Uint },
    0x15b8: { name: "ChromaSitingVert", type: SectionType_1.SectionType.Uint },
    0x15b9: { name: "Range", type: SectionType_1.SectionType.Uint },
    0x15ba: { name: "TransferCharacteristics", type: SectionType_1.SectionType.Uint },
    0x15bb: { name: "Primaries", type: SectionType_1.SectionType.Uint },
    0x15bc: { name: "MaxCLL", type: SectionType_1.SectionType.Uint },
    0x15bd: { name: "MaxFALL", type: SectionType_1.SectionType.Uint },
};
//# sourceMappingURL=sections.js.map